import type { T } from '../i18n';
import type { Nav } from '../hooks/useHashRoute';
import { CHAPTERS } from '../chapters/registry';

interface Props {
  t: T;
  onNav: Nav;
}

export function Home({ t, onNav }: Props) {
  const titleParts = t('home.title').split('\n');
  return (
    <div>
      <div className="home-hero">
        <div className="home-eyebrow">{t('home.eyebrow')}</div>
        <h1 className="home-title">
          {titleParts.map((line, i) => (
            <span key={i} style={{ display: 'block' }}>
              {i === titleParts.length - 1 ? <em>{line}</em> : line}
            </span>
          ))}
        </h1>
        <p className="home-lede">{t('home.lede')}</p>

        <div className="row" style={{ gap: 12 }}>
          <button
            className="iconbtn"
            onClick={() => onNav('ch11')}
            style={{
              padding: '10px 16px',
              fontSize: 14,
              background: 'var(--ink)',
              color: 'var(--paper)',
              borderColor: 'var(--ink)',
            }}
          >
            {t('home.start')}
          </button>
          <button
            className="iconbtn"
            onClick={() => onNav('ch02')}
            style={{ padding: '10px 16px', fontSize: 14 }}
          >
            §02 · Ch02
          </button>
        </div>

        <div className="home-stats">
          <div className="stat">
            <div className="stat-num">11</div>
            <div className="stat-label">{t('home.stat.chapters')}</div>
          </div>
          <div className="stat">
            <div className="stat-num">∞</div>
            <div className="stat-label">{t('home.stat.interact')}</div>
          </div>
          <div className="stat">
            <div className="stat-num">5</div>
            <div className="stat-label">{t('home.stat.decomp')}</div>
          </div>
          <div className="stat">
            <div className="stat-num">2D</div>
            <div className="stat-label">{t('home.stat.dim')}</div>
          </div>
        </div>
      </div>

      <div className="home-hero" style={{ paddingTop: 0 }}>
        <div className="home-grid">
          {CHAPTERS.map((c) => (
            <div key={c.id} className="home-card" onClick={() => onNav(c.id)}>
              <span className="home-card-num">§{c.num}</span>
              <div className="home-card-title">{t(`${c.id}.title`)}</div>
              <div className="home-card-desc">{t(`${c.id}.sub`)}</div>
              <span className="home-card-prio" data-prio={c.prio}>
                {c.prio}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
